import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function HotelRentalsSection() {
  const benefits = ['Free hotel delivery and pickup', 'All major hotels in the DMV covered', 'Available for business & leisure travelers', '100% Satisfaction guaranteed'];
  return <section id="hotel-rentals" className="py-24 bg-white overflow-hidden" data-id="element-214">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-215">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-216">
          {/* Image/Visual Left */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative order-2 lg:order-1" data-id="element-217">
            <div className="absolute -inset-4 bg-brand-navy/5 rounded-[2.5rem] transform -rotate-2 -z-10" data-id="element-218"></div>
            <img src="https://images.unsplash.com/photo-1566073771259-6a8506099945?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" alt="Luxury Hotel Entrance" className="rounded-3xl shadow-2xl object-cover w-full h-[500px]" data-id="element-219" />

            {/* Floating Badge */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.5
          }} className="absolute -bottom-6 -right-6 bg-brand-navy text-white p-6 rounded-2xl shadow-xl max-w-[200px]" data-id="element-220">
              <div className="text-3xl font-bold text-brand-red mb-1" data-id="element-221">100%</div>
              <div className="text-sm font-medium" data-id="element-222">
                Free Delivery to Your Hotel Doorstep
              </div>
            </motion.div>
          </motion.div>

          {/* Text Content Right */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="order-1 lg:order-2" data-id="element-223">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-brand-navy mb-4 leading-tight" data-id="element-224">
              Hotel Delivery Service
            </h2>
            <h3 className="text-xl text-brand-blue font-semibold mb-6" data-id="element-225">
              Mobility equipment delivered right to your hotel
            </h3>

            <p className="text-brand-charcoal/80 text-lg leading-relaxed mb-8" data-id="element-226">
              We understand that when traveling, mobility can be a concern. Our
              rental services cover Washington D.C., Maryland, Baltimore, and
              Northern Virginia, and we offer delivery services to various
              hotels in these areas. All you need to do is let us know your
              hotel's name and address, and we will deliver the equipment to
              your doorstep.
            </p>

            <ul className="space-y-4 mb-10" data-id="element-227">
              {benefits.map((benefit, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.3 + index * 0.1
            }} className="flex items-center gap-3" data-id="element-228">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-brand-red/10 flex items-center justify-center" data-id="element-229">
                    <CheckIcon className="w-4 h-4 text-brand-red font-bold" data-id="element-230" />
                  </div>
                  <span className="text-brand-navy font-medium" data-id="element-231">{benefit}</span>
                </motion.li>)}
            </ul>

            <a href="#reserve" className="inline-flex items-center justify-center px-8 py-4 bg-brand-navy text-white rounded-full font-bold text-lg hover:bg-brand-blue transition-colors shadow-lg hover:shadow-xl hover:-translate-y-1" data-id="element-232">
              Book Hotel Delivery
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}